module.exports = __webpack_public_path__ + "img/22_7.b034f832.png";